<router-outlet></router-outlet>
<app-footer-custom *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/login' || location == '/register' 
|| location == '/afkarena' || location == '/cotuong' || location == '/chatai' || location == '/coup' || location == '/summonerswar/test' || 
(location && location.indexOf('/admin') > -1))"></app-footer-custom>